import React, { useCallback } from 'react';
import cn from 'classnames';

import InteractiveTable from 'components/experiment/ui/InteractiveTable.component';
import MonthPicker from 'components/hr/targets/MonthPicker.component';
import { useTheme } from 'providers/Theme.provider';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import logger from 'utils/logger.util';
import C from 'utils/values/constant.util';

import CN from './TargetsLayout.module.scss';

const L = logger('TargetsLayout');

// TODO: remove this and use actual BE data
const data = C([
  { category: 'A', values: ['1', '2', '3', '1', '2', '3', '1', '2', '3', '1', '2', '3'] },
  { category: 'B', values: ['1', '2', '3', '1', '2', '3', '1', '2', '3', '1', '2', '3'] },
  { category: 'C', values: ['1', '2', '3', '1', '2', '3', '1', '2', '3', '1', '2', '3'] },
  { category: 'D', values: ['1', '2', '3', '1', '2', '3', '1', '2', '3', '1', '2', '3'] },
  { category: 'M', values: ['1', '2', '3', '1', '2', '3', '1', '2', '3', '1', '2', '3'] },
  { category: 'J', values: ['0', '0', '0', '1', '2', '3', '1', '2', '3', '1', '2', '3'] },
  { category: 'QQQ', values: ['22', '18', '11', '22', '18', '11', '22', '18', '11', '22', '18', '11'] },
  { category: 'DAC', values: ['10', '50', '100', '10', '50', '100', '10', '50', '100', '10', '50', '100'] },
]);

// TODO: remove this and use actual BE data
const columns = C([
  'John',
  'Maya',
  'Sol',
  'Bob',
  'Iron From the Feature is here. Real long name',
  'George',
  'kate',
  'Pipe',
  'Adam',
  'Yan',
  'Vivian',
  'Shon Pen',
]);

const TargetsLayout = () => {
  const { isDarkMode } = useTheme();

  const handleChange = useCallback((ev) => {
    L.debug('handleChange()', ev);
  }, []);

  const handleClose = alwaysNoop; // TODO: call BE or do something else

  const handleAdd = useCallback(
    () => ({
      first: <div> comp A </div>,
      cell: <div> comp B </div>,
    }),
    [],
  );

  return (
    <div
      data-bem="TargetsLayout"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.filter}>
        <div className={CN.title}>Staff Targets Setup</div>
      </div>

      <MonthPicker withOverlay autoclose onChange={handleChange} onClose={handleClose} />

      <InteractiveTable data={data} columns={columns} onAdd={handleAdd} />
    </div>
  );
};

export default TargetsLayout;
